import React, { Component } from 'react';
import SideMenu from '../../components/side_menu';
import { Switch, Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';


import AllDataOverview from './overview';

import ReconcilerGroupDetail from './reconcilers_detail';
import AgingFilteredData from './aging_filtered_data';
import ManualReconciled from './manual_reconciled';
import ManualPending from './manual_pending';
import UnreconciledData from './unreconciled_data';


import { getBreadcrumb } from '../../util/ui_util';
import MainLayout from '../main_layout';
import { DashboardOutlined, StorageOutlined } from '@material-ui/icons';
import ModalTransactionDetail from '../../components/modal_transaction_detail';
import { withDomains, RESTExecutor } from '../../lib/domain';
import { showErrorInNotification } from '../../lib/util';
import GroupList from './group_list';
import GroupDetail from './group_detail';
import GroupSourceDetail from './group_source_detail';
import GroupedUnreconciledData from './grouped_unreconciled_data';

const main_menu_2 = [
    {
        type: 'main',
        title: 'Overview',
        url: 'processors/overview',
        key: 'overview',
        icon: <DashboardOutlined className='menu-icon' />
    },
]

const main_menu = [
    {
        type: 'loading'
    },
]

class AllDataPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            side_items: [...main_menu_2, ...main_menu]
        };

        // this.state.side_items.splice(0,1)
        // console.log(this.state.side_items)

        this.list_group_items = RESTExecutor.list().config({
            label: 'list',
            params: {
                per_page: 10
            }
        }).callbacks((success) => {
            let items = [];
            success.result.rows.map((item) => {
                items.push({
                    type: 'main',
                    url: `processors/groups/${item.id}/sources`,
                    key_position: 3,
                    title: item.name,
                    key: item.id,
                    icon: <StorageOutlined className='menu-icon' />
                })
            });
            let prev_list = [...main_menu_2, ...main_menu]
            prev_list.splice(1, 1)
            let new_list = prev_list.concat(items);
            if (success.meta.total_count > 1) {
                new_list = [...new_list, {
                    type: 'content',
                    render: () => <center>View All</center>

                }]
            }
            this.setState({ side_items: new_list });
        }, (error) => {
            showErrorInNotification(error);
            let items = [{
                type: 'error',
                onReload: () => {
                    this.setState({
                        side_items: [...main_menu_2, ...main_menu]
                    }, () => {
                        this.list_group_items.execute()
                    });

                }
            }]
            let prev_list = [...main_menu, ...main_menu_2];
            prev_list.splice(1, 1);
            // console.log("prev list",prev_list)
            let new_list = prev_list.concat(items);
            this.setState({ side_items: new_list });

        }).connect(props.domains.usergroups);

        // this.list_group_items.execute()

    };



    render() {

        var pathName = this.props.location.pathname;
        return (<MainLayout
            onRef={(ref) => {
                window.slider_main = ref
            }}
            sliderContent={<SideMenu
                key='siderecon'
                menuKey={pathName}
                // item={side_items}
                item={[
                    // {
                    //     type: 'main',
                    //     title: 'Overview',
                    //     url: 'recon/overview',
                    //     key: 'overview',
                    //     // iconName: 'dashboard',
                    //     icon:<DashboardOutlined className='menu-icon'/>
                    // },
                    {
                        type: 'main',
                        title: 'Overview',
                        index: 'reconciliation',
                        limit: 10,
                        url: 'processors/groups',
                        urlMaker: (item) => `processors/groups/${item}/sources`,
                        key: 'groups',
                        icon: <DashboardOutlined className='menu-icon' />,
                        viewAll: 'processors/groups',
                        view_all_text: "View All Groups",
                        // no_search: true,
                        key_position: 3
                    },
                    // {
                    //     type: 'complex',
                    //     title: "Processor",
                    //     index: 'reconciliation',
                    //     icon: <FlipOutlined className='menu-icon'/>,
                    //     limit: 5,
                    //     api_url: '/my-reconcilers?favourite=true',
                    //     urlMaker: (item) => `recon/reconcilers/${item}`,
                    //     key: 'reconciler',
                    //     viewAll: 'recon/reconcilers',
                    //     view_all_text: "View All Reconcilers",
                    //     // no_search: true,
                    //     key_position: 3
                    // },
                    // {
                    //     type: 'complex',
                    //     title: "Transaction",
                    //     index: 'transaction',
                    //     icon: <StorageOutlined className='menu-icon'/>,
                    //     limit: 5,
                    //     api_url: '/my-data-types',
                    //     urlMaker: (item) => `recon/data-type/${item}/transactions`,
                    //     viewAll: 'recon/data-type',
                    //     view_all_text: "View All Datatype",
                    //     // no_search: true,
                    //     key_position: 3
                    // },
                    // {
                    //     type: 'complex',
                    //     title: "Tables",
                    //     index: 'tables',
                    //     icon: <GridOnOutlined className='menu-icon'/>,
                    //     limit: 5,
                    //     api_url: '/tables',
                    //     urlMaker: (item) => `recon/table/${item}`,
                    //     viewAll: 'recon/table',
                    //     view_all_text: "View All Tables",
                    //     // no_search: true,
                    //     key_position: 3
                    // },
                ]}
            />}
            pageTitle={"All Data"}
            pageRoutes={{ routes: getBreadcrumb(this.props.location.pathname) }}
            mainContent={<Switch>

                <Route path='/processors/groups/:group_id/sources/:source_id/reconcilers/:reconciler_id/filteredtransactions' component={AgingFilteredData} />
                <Route path='/processors/groups/:group_id/sources/:source_id/reconcilers/:reconciler_id/pending' component={ManualPending} />
                <Route path='/processors/groups/:group_id/sources/:source_id/reconcilers/:reconciler_id/reconciled' component={ManualReconciled} />
                <Route path='/processors/groups/:group_id/sources/:source_id/reconcilers/:reconciler_id/unreconciled' component={UnreconciledData} />
                <Route path='/processors/groups/:group_id/sources/:source_id/reconcilers/:reconciler_id/groupedunreconciled' component={GroupedUnreconciledData} />

                {/* <Route  path='/recon/reconcilers/:group_id/filteredtransactions' component={AgingFilteredData} />
                <Route  path='/recon/reconcilers/:group_id/pending' component={ManualPending} />
                <Route  path='/recon/reconcilers/:group_id/reconciled' component={ManualReconciled} />
                <Route  path='/recon/reconcilers/:group_id/unreconciled' component={UnreconciledData} /> */}
                {/* <Route  path='/recon/reconcilers/:group_id/:process_id/pending' component={PendingApprovalData} /> */}
                {/* <Route  path='/recon/reconcilers/:group_id' component={ReconcilerGroupDetail} /> */}
                {/* <Route  path='/recon/reconcilers' component={ReconcilerListView} /> */}

                <Route path='/processors/groups/:group_id/sources/:source_id/reconcilers/:reconciler_id' component={ReconcilerGroupDetail} />
                <Redirect from='/processors/groups/:group_id/sources/:source_id/reconcilers' to='/processors/groups/:group_id/sources/:source_id' />

                <Route path='/processors/groups/:group_id/sources/:source_id' component={GroupSourceDetail} />
                <Route path='/processors/groups/:group_id/sources' component={GroupDetail} />
                <Redirect from='/processors/groups/:group_id' to='/processors/groups' />

                <Route path='/processors/groups' component={GroupList} />


                <Route path='/processors/overview' component={AllDataOverview} />

                <Route path='/processors/:transaction_id' render={(props) => {
                    return <div style={{
                        margin: 8
                    }}><ModalTransactionDetail {...props} /></div>
                }}
                />
                <Redirect from='*' to='/processors/groups' />
            </Switch>}

        />)
    }
}

export default withDomains(AllDataPage, "usergroups");
